import { COMEET_EMBED } from './embed';
import type { ComeetEmbedConfig } from './types';

declare global {
    interface Window {
        COMEET?: {
            init: (config: {
                token: string;
                'company-uid': string;
                'company-name': string;
                color: string;
                'font-size': string;
            }) => void;
        };
    }
}

let scriptPromise: Promise<void> | null = null;

export const loadComeetScript = (): Promise<void> => {
    if (scriptPromise) {
        return scriptPromise;
    }
    scriptPromise = new Promise<void>((resolve, reject) => {
        if (window.COMEET) {
            return resolve();
        }
        const existing = document.getElementById('comeet-jsapi');
        if (existing) {
            existing.addEventListener('load', () => resolve(), { once: true });
            existing.addEventListener('error', reject, { once: true });
            return;
        }
        const s = document.createElement('script');
        s.id = 'comeet-jsapi';
        s.async = true;
        s.src = `${COMEET_EMBED.url}/${COMEET_EMBED.fileName}`;
        s.onload = () => resolve();
        s.onerror = reject;
        document.head.appendChild(s);
    });
    return scriptPromise;
};

export const initComeet = ({ token, companyId }: ComeetEmbedConfig) => {
    if (!window.COMEET) {
        return;
    }
    window.COMEET.init({
        token,
        'company-uid': companyId,
        'company-name': COMEET_EMBED.companyName,
        color: COMEET_EMBED.color,
        'font-size': COMEET_EMBED.fontSize,
    });
};
